const ConnectCard = ({ icon, link, label }) => {
    return (
        <a
            href={link}
            target={"blank"}
            className="cursor-pointer select-none text-3xl flex flex-col items-center gap-1"
        >
            {icon}
            <div className="text-sm font-bold text-blue-500 underline">{label}</div>
        </a>
    );
};

export default ConnectCard;
